import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  IconButton,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PriceCard from "../../../../components/price_card";
import BusinessDetails from "../../business_details";
import { LocalOffer } from "@mui/icons-material";
import PricingDetails from "../../../../components/price_details";
import PricingModal from "../../pricing";
import moment from "moment";

const PriceDetails = ({
  open,
  onClose,
  onClosed,
  onSubmit,
  trialMessage,
  selectedPlanDetails,
  setShowTrialDetails,
  setModalOpen,
  productDetails,
  setProductDetails,
  setSelectedPlanDetails,
  pricing,
  setPricing,
  actionType,
  selectedPlanIndex,
  setSelectedPlanIndex,
}) => {
  const [businessModalOpen, setBusinessModalOpen] = useState(false);
  const [offerText, setOfferText] = useState();
  const [offerFrom, setOfferFrom] = useState();
  const [offerTo, setOfferTo] = useState();
  const [offer, setOffer] = useState();
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);

  const cardColors = ["#FFEBEE", "#E8F5E9", "#E3F2FD", "#F3E5F5", "#FFF3E0"];
  const borderColors = ["#FF4081", "#4CAF50", "#1976D2", "#9C27B0", "#FF9800"];

  const handleCardClick = (index, price) => {
    setSelectedPlanIndex(index);
    setPricing(price);
  };

  const onBackToPriceDetails = () => {
    setBusinessModalOpen(false);
    setShowTrialDetails(false);
    setModalOpen(true);
  };

  const handleModalSubmit = () => {
    onClosed();
    if (actionType === "renew" || actionType === "trials") {
      setIsPricingModalOpen(true);
    } else if (actionType === "upgrade") {
      setIsPricingModalOpen(true);
    } else {
      setBusinessModalOpen(true);
    }
  };

  const handleCloseBusinessModal = () => {
    setBusinessModalOpen(false);
    // setPricing(null);
  };

  const uniqueOffers = [
    ...new Set(
      selectedPlanDetails?.productPlansPricing?.map((item) =>
        JSON.stringify({
          offer_text: item.offer_text,
          offer_valid_from: item.offer_valid_from,
          offer_valid_to: item.offer_valid_to,
          is_offer_applicable: item.is_offer_applicable,
        })
      )
    ),
  ];

  const offers = uniqueOffers?.map((offer) => JSON?.parse(offer));

  useEffect(() => {
    offers.forEach((item) => {
      setOfferText(item?.offer_text);
      setOfferFrom(moment.utc(item?.offer_valid_from).startOf("day"));
      setOfferTo(moment.utc(item?.offer_valid_to).endOf("day"));
      setOffer(item?.is_offer_applicable);
    });
  }, [offers]);

  const frequencyOrder = ["monthly", "quarterly", "halfyearly", "yearly"];

  const sortedFrequencies = selectedPlanDetails?.productPlansPricing?.sort(
    (a, b) =>
      frequencyOrder.indexOf(a.frequency) - frequencyOrder.indexOf(b.frequency)
  );

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
        BackdropProps={{
          onClick: (e) => e.stopPropagation(),
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
            boxShadow: 24,
            outline: "none",
            position: "relative",
            width: { xs: "70%", sm: "75%", md: "80%" },
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2">
            Price Details
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            {trialMessage}
          </Typography>
          {offer &&
            offerFrom &&
            offerTo &&
            new Date() >= new Date(offerFrom) &&
            new Date() <= new Date(offerTo) && (
              <Grid item xs={12}>
                <Card
                  sx={{
                    borderRadius: "15px",
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                    background:
                      "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                    color: "#ffffff",
                    padding: "0px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    fontSize: "14px",
                    fontWeight: "bold",
                    height: "auto",
                    overflow: "hidden",
                    transition:
                      "transform 0.3s ease-in-out, box-shadow 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                >
                  <CardContent
                    sx={{ padding: "0", width: "100%", marginBottom: "0" }}
                  >
                    <Typography
                      sx={{
                        display: "block",
                        margin: "0",
                        marginBottom: "0px",
                        color: "#ffffff",
                        marginTop: "10px",
                        textAlign: "center",
                        fontSize: "30px",
                        fontWeight: "bold",
                        letterSpacing: "1.5px",
                        fontFamily: "'Great Vibes', cursive",
                        fontStyle: "normal",
                        textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
                      }}
                      variant="h5"
                    >
                      {offerText
                        ? offerText.charAt(0).toUpperCase() + offerText.slice(1)
                        : "Limited Time Offer"}
                    </Typography>

                    <Typography
                      sx={{
                        display: "block",
                        margin: "0",
                        color: "#ffffff",
                        marginTop: "8px",
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                      }}
                    >
                      <span sx={{ fontWeight: "100" }}>Duration:</span>{" "}
                      {offerFrom && offerTo
                        ? `${moment
                            .utc(offerFrom)
                            .startOf("day")
                            .format("DD/MM/YYYY")} to ${moment
                            .utc(offerTo)
                            .endOf("day")
                            .format("DD/MM/YYYY")}`
                        : "Dates Not Available"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              {Array?.isArray(sortedFrequencies) &&
                sortedFrequencies?.map((pricing, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={pricing.prd_plan_pricing_uuid}
                  >
                    <PriceCard
                      name={
                        pricing?.frequency
                          ? pricing?.frequency?.charAt(0)?.toUpperCase() +
                            pricing?.frequency?.slice(1)
                          : ""
                      }
                      price={pricing?.frequency_price}
                      offerPrice={pricing?.offer_price}
                      description={pricing?.offer_text}
                      color={cardColors[index % cardColors?.length]}
                      borderColor={borderColors[index % borderColors?.length]}
                      selected={selectedPlanIndex === index}
                      onSelect={() => handleCardClick(index, pricing)}
                      pricing={pricing}
                      priceStyles={{
                        fontSize: {
                          xs: "29px",
                          sm: "22px",
                          md: "24px",
                        },
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            {selectedPlanIndex !== null && (
              <Button
                onClick={handleModalSubmit}
                sx={{
                  ml: 2,
                  background:
                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                  color: "#fff",
                  padding: "8px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "5px",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    background:
                      "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  },
                }}
              >
                Continue
              </Button>
            )}
          </Box>
        </Box>
      </Modal>

      <BusinessDetails
        open={businessModalOpen}
        onClose={handleCloseBusinessModal}
        onSubmit={onSubmit}
        trialMessage={trialMessage}
        plans={[]}
        onBackToPriceDetails={onBackToPriceDetails}
        productDetails={productDetails}
        setProductDetails={setProductDetails}
        selectedPlanDetails={selectedPlanDetails}
        setSelectedPlanDetails={setSelectedPlanDetails}
        setShowTrialDetails={setShowTrialDetails}
        pricing={pricing}
        setPricing={setPricing}
        setModalOpen={setModalOpen}
        actionType={actionType}
      />
      <PricingModal
        open={isPricingModalOpen}
        onClose={() => {
          setIsPricingModalOpen(false)
          onClose(); 
        }}
        productDetails={productDetails}
        setProductDetails={setProductDetails}
        selectedPlanDetails={selectedPlanDetails}
        setSelectedPlanDetails={setSelectedPlanDetails}
        pricing={pricing}
        setPricing={setPricing}
        setShowTrialDetails={setShowTrialDetails}
        actionType={actionType}
      />
    </>
  );
};

export default PriceDetails;
